import React, {Fragment, useState,useRef} from 'react';
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import './index.scss';
import Button from 'devextreme-react/button';
import Amazon from '../../settings/selling-channels/amazon/index';
import Shopify from '../../settings/selling-channels/shopify/index';
import Ebay from '../../settings/selling-channels/ebay/index';
import Etsy from '../../settings/selling-channels/etsy/index';
import SquareSpace from '../../settings/selling-channels/square-space/index';
import Magento from '../../settings/selling-channels/magento/index';
const Integrations = (props) => {
    const [contentID, setContentID] = useState('');
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);
    const childRef = useRef();
    const MarketPlaces = [
        {
            icon: 'fab fa-amazon',
            isUnderDev: true,
            title: 'Amazon',
            description: 'Connect your marketplaces from all the world with our single integration.'
        }, {
            icon: 'fab fa-ebay',
            isUnderDev: false,
            title: 'Ebay',
            description: 'Connect your ebay store with our single integration. '
        }, {
            icon: 'fab fa-etsy',
            isUnderDev: false,
            title: 'Etsy',
            description: 'Connect your etsy store with our single integration. '
        }, {
            icon: 'fab fa-magento',
            isUnderDev: true,
            title: 'Magento',
            description: 'Connect your magento platform with our single integration. '
        }, {
            icon: 'fab fa-shopify',
            isUnderDev: true,
            title: 'Shopify',
            description: 'Connect your shopify shop with our single integration. '
        }, {
            icon: 'fab fa-squarespace',
            isUnderDev: true,
            title: 'SquareSpace',
            description: 'Connect your squarespace store with our single integration. '
        }
    ];

    const ListMP = () => {
        const lists = MarketPlaces.map(item => {
            const title = () =>{
                return item.title;
            };
            return (
                <Button
                    id={item.title}
                    type={'normal'}
                    stylingMode={'text'}
                    className={'integrations-button'}
                    onClick={()=>{setIsPopUpVisible(true);setContentID(title());}}
                    >
                    <div className={'flex flex-row'}>
                        <div className={'m_2'}>
                            <i className={`${item.icon} integration-icon`}/>
                        </div>
                        <div className={'integration-description m_2'}>
                            <h5>
                                <b>{item.title}
                                    <sup className={'sup-text'}>{item.isUnderDev
                                            ? 'Beta'
                                            : ''}</sup>
                                </b>
                            </h5>
                            <span>{item.description}</span>
                        </div>
                    </div>
                </Button>
            )
        });
        return (
            <div className={'integration-content'}>{lists}</div>
        )
    }

    const  SellingChannel = () =>{
        switch(contentID){
            case 'Amazon': 
                return(<Amazon ref={childRef}/>);
            case 'Shopify':
                return(<Shopify ref={childRef}/>);
            case 'Ebay':
                 return(<Ebay ref={childRef}/>);
            case 'Etsy': 
                return(<Etsy ref={childRef}/>);
            case 'SquareSpace':
                return(<SquareSpace ref={childRef}/>);
            case 'Magento':
                return(<Magento ref={childRef}/>);
            {/*
                 case 'AliExpress':
                return(<AliExpress ref={childRef}/>);
            */}
            default:
                return 'Error 404 Page Not Found';
        }
     }

     const cancelButton = {
        text: 'cancel',
        onClick: () => {setContentID('');setIsPopUpVisible(false);}
    }

    const connectButton = {
        id: 'LoginWithAmazon',
        text: 'login',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: () => childRef
            .current
            .onSubmit()
    }
    return (
        <Fragment>
            <Popup
                showTitle={false}
                width={500}
                height={370}
                visible={isPopUpVisible}
                contentRender={SellingChannel}
                onHiding={e => {
                setContentID('');
                setIsPopUpVisible(false)
            }}>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={connectButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={cancelButton}></ToolbarItem>
            </Popup>
            <div id={'integration-content'}>
                <h4 className={'integration-title'}>Integrations</h4>
                <div>
                    <ListMP/>
                </div>
            </div>
        </Fragment>
    )
}

export default Integrations;
